/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';
import { type Contato } from './types';

const editarContato = (contato: Contato): AxiosPromise<*> => (
    xhr.put(`/contatos/${contato.id}`, contato)
);
const cadastrarContato = (contato: Contato): AxiosPromise<*> => (
    xhr.post('/contatos', contato)
);
const deletarContato = (id: number): AxiosPromise<*> => (
    xhr.delete(`/contatos/${id}`)
);

const cadastrarOuEditarOuDeletarContato = (contato: Contato) => {
    if (!contato.numero && contato.id) {
        return deletarContato(contato.id);
    }

    if (!contato.numero) {
        return Promise.resolve();
    }

    if (contato.id) {
        return editarContato(contato);
    }

    return cadastrarContato(contato);
};

export default cadastrarOuEditarOuDeletarContato;
